
import React from 'react';
import { Toaster } from '@/components/ui/toaster';
import { AppRoutes } from './AppRoutes';
import { AuthContext } from '@/context/AuthContext';

export const AppContent: React.FC = () => {
  const auth = React.useContext(AuthContext);

  if (!auth) {
    // Prevent rendering routes before AuthProvider is available
    return null;
  }

  return (
    <>
      <AppRoutes />
      <Toaster />
    </>
  );
};
